(() => {
  // Feature callouts: link the numbered hotspots on the photo with the list below it
  const hs = [...document.querySelectorAll('.hs')];
  const items = [...document.querySelectorAll('#parts li')];
  if (hs.length) {
    const set = (i) => {
      hs.forEach(b => b.classList.toggle('on', b.dataset.i === i));
      items.forEach(li => li.classList.toggle('on', li.dataset.i === i));
    };
    hs.forEach(b => {
      b.addEventListener('mouseenter', () => set(b.dataset.i));
      b.addEventListener('focus', () => set(b.dataset.i));
      b.addEventListener('click', () => {
        set(b.dataset.i);
        const li = items.find(l => l.dataset.i === b.dataset.i);
        if (li && window.matchMedia('(max-width: 860px)').matches) li.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    });
    items.forEach(li => li.addEventListener('mouseenter', () => set(li.dataset.i)));
    const bay = document.getElementById('callouts');
    const list = document.getElementById('parts');
    if (bay) bay.addEventListener('mouseleave', () => set(null));
    if (list) list.addEventListener('mouseleave', () => set(null));
  }

  // Gallery lightbox
  const lb = document.getElementById('lb');
  const lbImg = document.getElementById('lb-img');
  if (lb && lbImg) {
    document.querySelectorAll('.gallery button').forEach(btn => {
      btn.addEventListener('click', () => {
        lbImg.src = btn.dataset.src;
        lbImg.alt = btn.querySelector('img').alt;
        if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
      });
    });
    const closeLb = () => { if (lb.open) { if (lb.close) lb.close(); else lb.removeAttribute('open'); } };
    const x = document.getElementById('lb-x');
    if (x) x.addEventListener('click', closeLb);
    lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
  }
})();
